import {lazy} from "react";
import {usrPermission} from "../../config/userPermission";

const SiteInfo = lazy(() => import("./pages/SiteInfo"));

export const routes: any = [
    {
        path: "site-info",
        permission: usrPermission.siteInfo.r,
        element: <SiteInfo />,
    },
];